<template>
  <div class="container">
    <header>
      <div class="hea_title">
        <img src="../../assets/images/seckill/seckill_01.png" alt="" />
      </div>
      <swiper
        :options="swiperSeckill"
        ref="mySwiper"
        class="swiper_seckill"
        v-if="weekList.length"
      >
        <swiper-slide
          v-for="(item, index) in weekList"
          :key="index"
          :class="{ active: weeksNumber === index + 1 }"
        >
          <div class="hea_week">{{ item.desc }}</div>
          <div class="hea_status">{{ item.status }}</div>
        </swiper-slide>
      </swiper>
    </header>
    <van-list
      v-model="isUpLoading"
      :finished="upFinished"
      :offset="10"
      :immediate-check="false"
      :finished-text="$t('seckillPage.bottom_line')"
      @load="onLoadList"
      v-if="seckillList.length > 0"
    >
      <section
        v-for="item in seckillList"
        :key="item.id"
        @click="
          handlerSeckill(
            item.activityNo,
            item.productCode,
            item.productDetailCode,
            item.residueNum,
            item.welfareDisplay,
            item.status
          )
        "
      >
        <div class="sec_left">
          <img v-if="item.productImage" :src="item.productImage" alt="" />
        </div>
        <div class="sec_right">
          <div class="info_title txt_line_two">{{ item.productName }}</div>
          <div class="info_center" v-if="item.activityMark">
            <img src="../../assets/images/seckill/seckill_02.png" alt="" />
            <p class="txt_line_one">{{ item.activityMark }}</p>
          </div>
          <div class="info_box">
            <div class="progress_box">
              <span :style="`width: ${item.seckillProgress} %`"></span>
            </div>
            <p v-if="item.residueNum > 0">
              {{ $t('seckillPage.soldout') }} {{ item.seckillProgress }} %
            </p>
            <p v-else>{{ $t('seckillPage.outofstock') }}</p>
          </div>
          <div class="info_foo">
            <div class="new_price font_num_bold">
              ￥{{ item.seckillPrice | numFilter }}
            </div>
            <div class="old_price font_num">
              ￥{{ item.marketPrice | numFilter }}
            </div>
          </div>
          <div class="info_btn">
            <p v-if="item.status === 1">{{ $t('seckillPage.remindme') }}</p>
            <p v-else-if="item.residueNum <= 0 && item.welfareDisplay === 1">
              {{ $t('seckillPage.originalprice') }}
            </p>
            <p v-else-if="item.residueNum > 0 && item.status === 2">
              {{ $t('seckillPage.buyitnow') }}
            </p>
            <p v-else class="active">{{ $t('seckillPage.outofstock') }}</p>
          </div>
        </div>
      </section>
    </van-list>
    <!-- 缺省 -->
    <div class="no_more" v-else>
      <img src="../../assets/images/seckill/no_more.png" alt="" />
      <p>{{ $t('seckillPage.activelyrestocking') }}</p>
    </div>
    <div class="mask" v-show="showMask" @click="closeMask($event)">
      <div class="mask_box" ref="mask">
        <div class="mask_con">
          {{ $t('seckillPage.tip') }}
        </div>
        <div class="mask_confirm" @click="handleConfirm">
          {{ $t('seckillPage.ok') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import urlConfig from '../../config/urlConfig'
export default {
  data () {
    const App = this
    return {
      swiperSeckill: {
        observer: true,
        observeParents: true,
        initialSlide: App.weeksNumber + 1,
        slidesPerView: 5,
        on: {
          click () {
            App.isUpLoading = false
            App.upFinished = false
            App.pageNo = 1
            App.seckillList = []
            App.weeksNumber = this.clickedIndex + 1
            App.getList(this.clickedIndex + 1)
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      weekList: [],
      isUpLoading: false,
      upFinished: false,
      showMask: false,
      seckillList: [],
      pageNo: 1,
      pageSize: 5,
      weeksNumber: '',
      remindActivityNo: '',
      ssoToken: this.$localStorageUtil.getCurrentUserToken()
    }
  },
  created () {
    // 初始化轮播
    this.getWeek().then(res => {
      this.getWeekStatus()
      this.getList(res)
    })
    this.shareInit()
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    getList (week = this.weeksNumber) {
      var param = {
        params: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          weeksNumber: week
        }
      }
      this.axios.get(this.$urlConfig.fafuliSeckillApiUrl() + 'activity/activity_list', param).then(res => {
        if (res.data.return_code === '00') {
          const rows = res.data.data.entities
          if (rows == null || rows.length === 0) {
            // 加载结束
            this.upFinished = true
            return
          }
          if (rows.length < this.pageSize) {
            // 最后一页不足10条的情况
            this.upFinished = true
          }
          // 处理数据
          if (this.pageNo === 1) {
            this.seckillList = rows
          } else {
            this.seckillList.push(...rows)
          }
        } else {
          console.log(res.data.return_msg)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.isUpLoading = false
      }).then(() => {
      })
    },
    // 获取每周状态
    async getWeekStatus () {
      const res = await this.axios.get(this.$urlConfig.fafuliSeckillApiUrl() + 'activity/count_status')
      if (res.data.return_code === '00') {
        this.weekList = res.data.data.entity
      }
    },
    // 上拉加载请求方法
    onLoadList () {
      this.pageNo++
      this.getList()
    },
    // 获取星期
    getWeek () {
      var arr = [7, 1, 2, 3, 4, 5, 6]
      var day = new Date().getDay()
      this.weeksNumber = arr[day]
      this.swiperSeckill.initialSlide = this.weeksNumber - 1
      return new Promise((resolve, reject) => {
        resolve(this.weeksNumber)
      })
    },
    handlerSeckill (activityNo, productCode, productDetailCode, residueNum, welfareDisplay, status) {
      if (status === 1) {
        // 提醒我
        this.showMask = true
        this.remindActivityNo = activityNo
      } else if (residueNum <= 0 && welfareDisplay === 1) {
        // 原价购
        window.location.href = this.$urlConfig.fafuliWxAdminUrl() + 'product/detailRouter?productCode=' + productCode + '&productDetailCode=' + productDetailCode
      } else if (residueNum > 0 && status === 2) {
        // 马上抢
        this.$router.push({
          path: '/productDetail',
          query: {
            activityNo
          }
        })
      }
    },
    handleConfirm () {
      this.showMask = false
      const param = {
        activityNo: this.remindActivityNo,
        ssoToken: this.ssoToken
      }
      this.axios.post(this.$urlConfig.fafuliSeckillApiUrl() + 'activity/remind', param).then(res => {
        if (res.data.return_code === '00') {
          this.$toast(this.$t('seckillPage.reminder'))
        } else {
          this.$toast(res.data.return_msg)
        }
      })
    },
    closeMask (e) {
      if (!this.$refs.mask.contains(e.target)) {
        this.showMask = false
      }
    },
    // 邀请微信分享
    shareInit () {
      // 微信分享初始化
      const shareObj = {
        link: window.location.href,
        title: this.$t('seckillPage.sekill'),
        desc: this.$t('seckillPage.act'),
        imgUrl: this.$urlConfig.ossImgUrl() + 'fafuli-seckill/ui/f32bc20ed12f72f67e158d2cb341a16.png'
      }
      this.$shareUtil.shareInit(shareObj)
    }
  },
  filters: {
    numFilter (val) {
      if (val) {
        // 截取当前数据到小数点后两位
        const realVal = parseFloat(val).toFixed(2)
        return realVal
      } else {
        return '0.00'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    const agent = navigator.userAgent
    const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    const path = '/seckill' + to.path
    if (isiOS && (path !== location.pathname)) {
      // 此处不可使用location.replace
      location.assign(urlConfig.localUrl() + to.fullPath)
    } else {
      next()
    }
  }
}
</script>
<style lang='scss' scoped>
$fontNum: 'pingfang-medium-num';
$fontNumBold: 'pingfang-sc-bold';

.font_num {
  font-family: $fontNum;
}
.font_num_bold {
  font-family: $fontNumBold;
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  list-style: none;
  touch-action: auto;
}
img {
  width: 100%;
  height: 100%;
}
.txt_line_two {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;
  white-space: normal;
  word-break: break-all;
}
.txt_line_one {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-wrap: break-word;
  white-space: normal;
  word-break: break-all;
}
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding: vw(113) 0 vw(14);
  overflow: scroll;
}
header {
  width: 100%;
  height: vw(113);
  padding: vw(14) vw(13) vw(15);
  background: linear-gradient(
    135deg,
    rgba(255, 107, 0, 1) 0%,
    rgba(255, 164, 0, 1) 100%
  );
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  .hea_title {
    width: vw(120);
    height: vw(31);
    margin: 0 auto;
  }
  /deep/ .swiper_seckill {
    color: rgba(255, 255, 255, 0.5);
    font-size: vw(13);
    --swiper-navigation-size: vw(10);
    .swiper-slide {
      margin-top: vw(17);
      text-align: center;
      .hea_status {
        padding-top: vw(2);
      }
      &.active {
        font-size: vw(18);
        font-weight: 700;
        color: #fff;
        margin-top: vw(13);
        .hea_week {
          line-height: vw(25);
        }
        .hea_status {
          font-size: vw(12);
          padding-top: vw(0);
        }
      }
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    width: vw(30);
    height: vw(10);
    top: 60%;
    background-size: vw(4) vw(10);
  }
  .swiper-button-prev {
    left: 0;
  }
  .swiper-button-next {
    right: 0;
  }
}
section {
  margin: vw(14) vw(13) 0;
  background-color: #fff;
  box-shadow: vw(2) vw(2) vw(10) vw(0) rgba(125, 81, 39, 0.1);
  border-radius: vw(8);
  display: flex;
  .sec_left {
    padding: vw(20) 0 vw(19) vw(10);
    width: vw(106);
    img {
      width: vw(98);
      height: vw(98);
      border-radius: vw(5);
    }
  }
  .sec_right {
    margin: vw(14) vw(13);
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .info_title {
      font-size: vw(14);
      color: #323232;
    }
    .info_center {
      font-size: vw(12);
      color: #ff8c00;
      padding-top: vw(6);
      display: flex;
      align-items: center;
      line-height: vw(17);
      img {
        width: vw(12);
        height: vw(13);
        margin-right: vw(6);
        display: inline-block;
      }
    }
    .info_box {
      display: flex;
      align-items: center;
      padding-top: vw(7);

      .progress_box {
        width: vw(112);
        height: vw(4);
        background-color: #fff2e2;
        border-radius: vw(7);
        position: relative;
        span {
          position: absolute;
          top: 0;
          left: 0;
          display: inline-block;
          width: 30%;
          height: vw(4);
          background-color: #ff8c00;
          border-radius: vw(7);
        }
      }
      p {
        font-size: vw(9);
        color: #ff8c00;
        padding-left: vw(7);
      }
    }
    .info_foo {
      padding-top: vw(4);
      display: flex;
      align-items: center;
      .new_price {
        font-size: vw(17);
        font-weight: 700;
        color: #ff8c00;
        padding-right: vw(5);
      }
      .old_price {
        font-size: vw(12);
        color: #9b9b9b;
        text-decoration: line-through;
      }
    }
    .info_btn {
      position: absolute;
      bottom: 0;
      right: 0;
      p {
        min-width: vw(70);
        height: vw(24);
        padding: 0 vw(4);
        border-radius: vw(12);
        background-color: #ff8c00;
        color: #fff;
        text-align: center;
        line-height: vw(24);
        font-size: vw(14);
      }
      p.active {
        background-color: #cfcfcf;
      }
    }
  }
}
.no_more {
  img {
    width: vw(230);
    height: vw(137);
    margin: vw(114) auto vw(15);
    display: block;
  }
  p {
    color: #a4aab3;
    font-size: vw(14);
    text-align: center;
  }
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 101;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  .mask_box {
    position: fixed;
    top: 45%;
    left: 50%;
    width: vw(280);
    overflow: hidden;
    font-size: vw(14);
    background-color: #fff;
    border-radius: vw(5);
    transform: translate3d(-50%, -50%, 0);
    transition: 0.3s;
    padding: vw(20) vw(48);
    color: #323232;
    text-align: center;
    .mask_confirm {
      width: vw(89);
      height: vw(40);
      line-height: vw(40);
      color: #fff;
      border-radius: vw(20);
      background-color: #ff8400;
      margin: vw(11) auto 0;
    }
  }
}
</style>
